import { encryptLoginPassword } from '@tiger/api-signature';
import { Button, Form, Input } from 'antd';
import React, { useMemo } from 'react';
import { $Formutil, useForm, withForm } from 'react-antd-formutil';
import FormItem from 'components/FormItem';
import { ModalHandler } from 'components/Modal';
import OnetimeCode from 'components/OnetimeCode';
import Toast from 'components/Toast';
import API from 'utils/API';
import http from 'utils/http';
import './style.scss';

interface SafeVerifyProps extends ModalHandler {
    $formutil: $Formutil<{
        login_password: string;
        otp_code: string;
    }>;
}

const SafeVerify: React.FC<SafeVerifyProps> = ({ close }) => {
    const $formutil = useForm();
    const { $invalid, $batchState, $getFirstError, $params } = $formutil;

    const disabled = useMemo(() => {
        if ($params.login_password && $params.otp_code?.length === 6) {
            return false;
        }

        return true;
    }, [$params]);

    const handleSubmit = async () => {
        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            const { otp_code } = $params;

            Toast.loading(true);

            try {
                await http.post(API.OAUTH.verifyPassword(), {
                    process: 'fund',
                    pwd_api_ver: 'v2',
                    login_password: encryptLoginPassword($params.login_password)
                });

                const { verify_token } = await http
                    .post(API.OAUTH.verifyOtp(), { otp_code, process: 'fund' })
                    .then(({ data }) => data);

                Toast.loading(false);

                close({
                    verify_token,
                    otp_code
                });
            } catch (error) {
                Toast.loading(false);
                Toast.show(error);
            }
        }
    };

    return (
        <div className="safe-verify-root">
            <Form layout="vertical" noValidate onFinish={handleSubmit}>
                <FormItem
                    name="login_password"
                    label={__('Login Password')}
                    checker={value => !!value || __('Please enter login password')}>
                    <Input type="password" placeholder={__('Login Password')} autoComplete="new-password" />
                </FormItem>
                <div className="auth-label">
                    {__('the 6-digit dynamic password displayed on the TradeUP Authenticator')}
                </div>
                <OnetimeCode
                    name="otp_code"
                    autoFocus={false}
                    checker={value => !!value || __('Please enter the 6-digit dynamic password')}
                />
                <Button disabled={disabled} className="btn-important" block htmlType="submit" type="primary">
                    {__('Confirm')}
                </Button>
            </Form>
        </div>
    );
};

export default withForm(SafeVerify);
